import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo el producto?',
  answer: 'El acceso se envía directamente a tu correo electrónico inmediatamente después de la compra. Puedes descargarlo en cualquier dispositivo.'
}, {
  question: '¡No tengo suficiente espacio en mi congelador!',
  answer: 'Yo preparo un mes completo usando solo el congelador de mi refrigerador normal. Ocupa mucho menos espacio del que piensas gracias a nuestra técnica de "empaque plano".'
}, {
  question: 'Tengo intolerancias alimentarias.',
  answer: 'Como mamá consciente de la salud, me tomo esto en serio. Todas las guías incluyen alternativas sin lácteos y sin gluten.'
}, {
  question: '¿Por qué esto sabe mejor que otras comidas congeladas?',
  answer: 'Por el Escudo de Frescura por Capas. Al organizar los ingredientes en el orden correcto, evitamos que los sabores se mezclen y detenemos las "quemaduras por congelación" que arruinan la textura. Saben frescas porque se están cocinando por primera vez en tu hogar.'
}, {
  question: '¿Hay garantía?',
  answer: '¡Sí! Ofrezco una garantía de devolución de dinero de 30 días. Si no te encanta, te devuelvo tu dinero.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-gray-50 px-4 py-10 md:py-20 lg:px-8" data-id="element-72">
      <div className="mx-auto max-w-3xl" data-id="element-73">
        <h2 className="mb-12 text-center font-serif text-3xl font-bold text-text-dark md:text-4xl" data-id="element-74">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-75">
          {faqs.map((faq, index) => <div key={index} className="overflow-hidden rounded-xl bg-white shadow-sm transition-shadow hover:shadow-md" data-id="element-76">
              <button onClick={() => toggleFAQ(index)} className="flex w-full items-center justify-between p-6 text-left focus:outline-none" data-id="element-77">
                <span className="text-lg font-bold text-text-dark" data-id="element-78">
                  {faq.question}
                </span>
                <ChevronDown className={`h-5 w-5 text-terracotta transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-79" />
              </button>

              <AnimatePresence data-id="element-80">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-81">
                    <div className="border-t border-gray-100 px-6 pb-6 pt-2 text-text-dark/80" data-id="element-82">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};